import { render, staticRenderFns } from "./CompanyShowPage.vue?vue&type=template&id=71542027&"
import script from "./CompanyShowPage.vue?vue&type=script&lang=ts&"
export * from "./CompanyShowPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports